import React from 'react'
import { Images } from '../../assets/scripts/Images'
import { notAllowEnterNumber } from '../../assets/scripts/GeneralFunctions'

function IRPlate({ first, letter, second, state, inputHandler, isSubmit }) {
  const plate_letters = [
    'الف',
    'ب',
    'پ',
    'ت',
    'ث',
    'ج',
    'د',
    'س',
    'ص',
    'ط',
    'ق',
    'ل',
    'م',
    'ن',
    'و',
    'ه',
    'ی',
    'ز',
    'ژ',
    'ش',
    'ع',
    'ف',
    'ک',
    'گ',
    'D',
    'S',
  ]
  return (
    <div
      className={
        'w-full h-16 flex border border-black dark:border-gray-700 rounded bg-white dark:bg-slate-800 mt-2'
      }
    >
      <div className="w-16 flex flex-col justify-center items-center border-l border-l-black dark:border-gray-700">
        <span className={'text-xs text-black dark:text-amber-50  mb-1'}>ایران</span>
        <input
          disabled={isSubmit}
          className={
            'bg-plate rounded-md text-center dark:bg-slate-700 dark:text-amber-50 w-9 h-9 focus:outline-0'
          }
          type="number"
          min="0"
          inputMode="numeric"
          pattern="[0-9]*"
          max={99}
          onKeyPress={(e) => notAllowEnterNumber(e, 2)}
          name={'state'}
          value={state}
          onChange={inputHandler}
        />
      </div>
      <div className="w-68 flex items-center justify-around">
        <input
          disabled={isSubmit}
          className={
            'bg-plate rounded-md text-center dark:bg-slate-700 dark:text-amber-50 w-24 h-11 focus:outline-0'
          }
          onKeyPress={(e) => notAllowEnterNumber(e, 3)}
          type="number"
          min="0"
          inputMode="numeric"
          pattern="[0-9]*"
          max={999}
          name={'second'}
          value={second}
          onChange={inputHandler}
        />
        <select
          disabled={isSubmit}
          className={
            'bg-plate rounded-md text-center dark:bg-slate-700 dark:text-amber-50 w-16 h-11 focus:outline-0'
          }
          name="letter"
          id="letter"
          value={letter}
          onChange={inputHandler}
        >
          {plate_letters.map((item) => (
            <option value={item} key={item}>
              {item}
            </option>
          ))}
        </select>
        <input
          disabled={isSubmit}
          className={
            'bg-plate rounded-md text-center dark:bg-slate-700 dark:text-amber-50 w-12 h-11 focus:outline-0'
          }
          type="number"
          min="0"
          inputMode="numeric"
          pattern="[0-9]*"
          onKeyPress={(e) => notAllowEnterNumber(e, 2)}
          max={99}
          name={'first'}
          value={first}
          onChange={inputHandler}
        />
      </div>
      <div className="bg-[#0044AA] rounded-l rounded-r-0 p-1 w-9 mr-auto flex flex-col justify-between">
        <img src={Images.iran} className={'py-1'} alt="iran flag" />
        <div className="flex flex-col justify-end">
          <img src={Images.IR} className={'py-1'} alt="iran flag" />
        </div>
      </div>
    </div>
  )
}

export default React.memo(IRPlate)
